import * as i0 from '@angular/core';
import { Injectable, Pipe, forwardRef, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpClientModule } from '@angular/common/http';
import * as i3 from '@angular/material/autocomplete';
import { MatAutocompleteTrigger, MatAutocompleteModule } from '@angular/material/autocomplete';
import { fromEvent } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import * as i6 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i4 from '@angular/material/core';
import { MatRippleModule } from '@angular/material/core';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

class EIPAutoCompleteService {
    constructor(http) {
        this.http = http;
    }
    httpPostCallWithHeader(WebApiURL, requestBody, headersParams) {
        const body = requestBody;
        return this.http.post(WebApiURL, body, { headers: headersParams });
    }
    getAutoCompleteList(body, apiURL) {
        // this.paramValue = parameters.value;
        const head = new HttpHeaders();
        head.append('Access-Control-Allow-Headers', 'Content-Type');
        head.append('Access-Control-Allow-Methods', 'GET');
        head.append('Access-Control-Allow-Origin', '*');
        return this.http.post(apiURL, body, { headers: head });
    }
}
EIPAutoCompleteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPAutoCompleteService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
EIPAutoCompleteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPAutoCompleteService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPAutoCompleteService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class EmittingValues {
}

class AutoCompleteHelper {
    getEmittingValues(selectedElement) {
        const emittingValues = new EmittingValues();
        emittingValues.value = selectedElement.value;
        emittingValues.text = selectedElement.text;
        emittingValues.desc = selectedElement.desc;
        emittingValues.additionalValues = selectedElement;
        return emittingValues;
    }
    filterTempList(tempList, selValue) {
        const codeList = tempList.filter(option => option.text.toLowerCase().trim().includes(selValue.toLowerCase().trim())).slice(0, 50);
        return codeList.sort((a, b) => {
            if (a.text < b.text) {
                return -1;
            }
            else if (a.text > b.text) {
                return 1;
            }
            else {
                return 0;
            }
        });
    }
    filterExactTempList(tempList, selValue) {
        // const codeList = tempList.filter(option =>
        //         option.text.replace(/\s/g, '').toLowerCase().trim() === (selValue.replace(/\s/g, '').toLowerCase().trim())
        //         );
        const matchedItem = tempList.find(item => item.value.toString() === selValue);
        return matchedItem;
    }
    isExactMatchInList(tempList, selValue) {
        let isExactMatch = false;
        if (selValue && tempList) {
            const codeList = tempList.filter(option => option.text.replace(/\s/g, '').toLowerCase().trim() === (selValue.replace(/\s/g, '').toLowerCase().trim()));
            if (codeList && codeList.length > 0) {
                isExactMatch = true;
            }
        }
        return isExactMatch;
    }
    isIncludeInList(tempList, selValue) {
        let isIncludeInList = false;
        const codeList = tempList.filter(option => option.text.toLowerCase().trim().includes(selValue.toLowerCase().trim())).slice(0, 50);
        if (codeList && codeList.length > 0) {
            isIncludeInList = true;
        }
        return isIncludeInList;
    }
    getAutoCompleteList(collectionResult, showTextValueField, textField, valueField, displaySettings) {
        let autoCompleteList = [];
        let isDisplaySettingsAvailable = false;
        let displayMode = 'value-text';
        let toolTipMode = displayMode;
        if (displaySettings && JSON.stringify(displaySettings) !== '{}') {
            isDisplaySettingsAvailable = true;
            if (displaySettings.view) {
                displayMode = displaySettings.view;
            }
            if (displaySettings.tooltip) {
                toolTipMode = displaySettings.tooltip;
            }
        }
        if (showTextValueField === 'Y') {
            if (displayMode === 'value-text') {
                if (toolTipMode === displayMode) {
                    autoCompleteList = collectionResult.map((n) => ({
                        value: n[valueField],
                        text: n[valueField] + ' - ' + n[textField].toString().trim(),
                        desc: n[textField].toString().trim(),
                        tooltip: n[valueField] + ' - ' + n[textField].toString().trim(),
                        additionalValues: n
                    }));
                }
                else if (toolTipMode === 'text') {
                    autoCompleteList = collectionResult.map((n) => ({
                        value: n[valueField],
                        text: n[valueField] + ' - ' + n[textField].toString().trim(),
                        desc: n[textField].toString().trim(),
                        tooltip: n[textField].toString().trim(),
                        additionalValues: n
                    }));
                }
                else {
                    autoCompleteList = collectionResult.map((n) => ({
                        value: n[valueField],
                        text: n[valueField] + ' - ' + n[textField].toString().trim(),
                        desc: n[textField].toString().trim(),
                        tooltip: n[textField].toString().trim() + ' - ' + n[valueField],
                        additionalValues: n
                    }));
                }
            }
            else if (displayMode === 'text-value') {
                if (toolTipMode === displayMode) {
                    autoCompleteList = collectionResult.map((n) => ({
                        value: n[valueField],
                        text: n[textField].toString().trim() + ' -' + n[valueField],
                        desc: n[textField].toString().trim(),
                        tooltip: n[textField].toString().trim() + ' - ' + n[valueField],
                        additionalValues: n
                    }));
                }
                else if (toolTipMode === 'text') {
                    autoCompleteList = collectionResult.map((n) => ({
                        value: n[valueField],
                        text: n[textField].toString().trim() + ' -' + n[valueField],
                        desc: n[textField].toString().trim(),
                        tooltip: n[textField].toString().trim(),
                        additionalValues: n
                    }));
                }
                else {
                    autoCompleteList = collectionResult.map((n) => ({
                        value: n[valueField],
                        text: n[textField].toString().trim() + ' - ' + n[valueField],
                        desc: n[textField].toString().trim(),
                        tooltip: n[valueField] + ' - ' + n[textField].toString().trim(),
                        additionalValues: n
                    }));
                }
            }
        }
        else if (showTextValueField === 'N') {
            if (toolTipMode === 'value-text') {
                autoCompleteList = collectionResult.map((n) => ({
                    value: n[valueField],
                    text: n[textField].toString().trim(),
                    desc: n[textField].toString().trim(),
                    tooltip: n[valueField] + ' - ' + n[textField].toString().trim(),
                    additionalValues: n
                }));
            }
            else if (toolTipMode === 'text-value') {
                autoCompleteList = collectionResult.map((n) => ({
                    value: n[valueField],
                    text: n[textField].toString().trim(),
                    desc: n[textField].toString().trim(),
                    tooltip: n[textField].toString().trim() + ' - ' + n[valueField],
                    additionalValues: n
                }));
            }
            else {
                autoCompleteList = collectionResult.map((n) => ({
                    value: n[valueField],
                    text: n[textField].toString().trim(),
                    desc: n[textField].toString().trim(),
                    tooltip: n[textField].toString().trim(),
                    additionalValues: n
                }));
            }
        }
        return autoCompleteList;
    }
    getTooltipText(item, type) {
        let tooltip = '';
        if (item) {
            if (type === 'text') {
                tooltip = item.des;
            }
            else if (type === 'value') {
                tooltip = item.value;
            }
            else if (type === 'text-value') {
                tooltip = `${item.desc} - ${item.value}`;
            }
            else {
                tooltip = tooltip;
            }
        }
        return tooltip;
    }
    get emptyItem() {
        return { value: '-2', text: '', desc: '', additionalValues: {} };
    }
    get noRecordItem() {
        return {
            value: '-3', text: 'No records found', desc: 'No records found',
            additionalValues: {
                value: '-3',
                text: 'No records found',
                tooltip: 'No records found'
            }
        };
    }
    get clearItem() {
        return { value: '-5', text: '', desc: '', additionalValues: {} };
    }
    mappingAutocompleteItem(text) {
        return {
            value: '-1',
            text,
            desc: text,
            tooltip: text,
            additionalValues: {}
        };
    }
}

class HighlightSearch {
    // transform(value: any, args: any): any {
    //     if (!args) { return value; }
    //     var re = new RegExp(args, 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
    //     return value.replace(re, "<mark>" + args + "</mark>");
    // }
    transform(value, args) {
        if (!args) {
            return value;
        }
        // const invalid = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_-]+/g;
        const invalid = /[°()\[\]{}\\+*]+/g;
        const repl = args.replace(invalid, '');
        // console.log(repl);
        const re = new RegExp(repl, 'gi');
        //  const re = new RegExp(args, 'gi'); // 'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
        return value.replace(re, match => {
            return `<span class="highlightText">${match}</span>`;
        });
    }
}
HighlightSearch.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HighlightSearch, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
HighlightSearch.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HighlightSearch, name: "highlight" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: HighlightSearch, decorators: [{
            type: Pipe,
            args: [{
                    name: 'highlight'
                }]
        }] });

const noop = () => {
};
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EIPAutoCompleteComponent),
    multi: true
};
class EIPAutoCompleteComponent {
    constructor(autoCompleteService) {
        this.autoCompleteService = autoCompleteService;
        // by the Control Value Accessor AfterViewInit
        this.onTouchedCallback = noop;
        this.onChangeCallback = noop;
        this.IsDisabled = false;
        this.ShowTextValueField = 'Y';
        this.Max = 50;
        this.selectedIndex = -1;
        this.valueChange = new EventEmitter();
        this.clearValue = 'N';
        this.dataSource = [];
        this.displaySettings = {};
        this.expandOptions = false;
        this.floatLabelOption = '';
        this.SingleValueBind = true;
        this.typeEmitted = false;
        this.IsDataOnload = true;
        this.isRequired = false;
        this.SearchTextKey = 'strSearchText';
        this.isSpinnerRequired = false;
        this.NoSelectiontoolTip = '';
        this.ClearListCollection = 'N';
        this.isLoading = false;
        this.isLoadingEnabled = false;
        this.ToolTipType = 'value-text';
        this.codeList = [];
        this.codeListTemp = [];
        this.filetredVlueTemp = [];
        this.selValue = '';
        this.defaultScrollCount = 50;
        this.prevTextedValue = '';
        this.toolTipText = '';
        this.isDependentSelected = false;
        this.emittedValue = '';
        this.autocompleteHelper = new AutoCompleteHelper();
        this.isIncludeInList = false;
        this.originalControlParams = {};
        this.optionStyles = '';
        this.originalValue = '';
        this.loadApiCount = 0;
        this.allowedDownKeys = [46];
        this.keyUpTimer = 0;
        this.regExp = /[A-Za-z0-9]+/g;
    }
    ngOnInit() {
        if (this.displaySettings && JSON.stringify(this.displaySettings) !== '{}') {
            if (this.displaySettings.tooltip) {
                this.ToolTipType = this.displaySettings.tooltip;
            }
        }
        if (this.IsDataOnload) {
            if (!this.IsCascading) {
                if (this.dataSource && this.dataSource.length == 0) {
                    this.isDependentSelected = false;
                    this.LoadList(this.WebAPIUrl, this.ControlParameters, this.TextField, this.ValueField, this.ShowTextValueField, false, this.selectedIndex);
                }
                else {
                    if (this.dataSource && this.dataSource.length > 0) {
                        if (this.selectedIndex !== -1) {
                            this.procesAutocomplete(this.dataSource, this.selectedIndex);
                        }
                        else {
                            this.procesAutocomplete(this.dataSource);
                        }
                    }
                }
            }
        }
        else if (!this.IsDataOnload && this.defaultValue) {
            if (!this.IsCascading) {
                if (this.dataSource && this.dataSource.length == 0) {
                    this.isDependentSelected = false;
                    this.LoadList(this.WebAPIUrl, this.ControlParameters, this.TextField, this.ValueField, this.ShowTextValueField, false, this.selectedIndex);
                }
                else {
                    if (this.dataSource && this.dataSource.length > 0) {
                        if (this.selectedIndex !== -1) {
                            this.procesAutocomplete(this.dataSource, this.selectedIndex);
                        }
                        else {
                            this.procesAutocomplete(this.dataSource);
                        }
                    }
                }
            }
        }
    }
    ngOnChanges(event) {
        this.toolTipText = this.NoSelectiontoolTip ? this.NoSelectiontoolTip : this.toolTipText;
        let selectedItem = {};
        if (event.hasOwnProperty('clearValue')) {
            if (event.clearValue.currentValue && event.clearValue.currentValue === 'Y') {
                this.callEvent({ text: '', value: '' });
            }
        }
        if (this.ClearListCollection === 'Y') {
            this.selValue = '';
            this.value = '';
            this.codeListTemp = [];
            this.codeList = [];
            this.ClearListCollection = 'N';
            this.defaultValue = null;
            this.loadApiCount = 0;
            this.previousEmittedItem = null;
            selectedItem = this.autocompleteHelper.noRecordItem;
            this.emitSelectedValue(selectedItem, true);
            return;
        }
        if (this.IsDataOnload) {
            if (this.IsCascading) {
                if ((this.ControlParameters &&
                    (JSON.stringify(this.ControlParameters) !== '{}')) &&
                    (this.dataSource || this.dataSource.length == 0)) {
                    if (JSON.stringify(this.originalControlParams) == '{}' ||
                        (JSON.stringify(this.originalControlParams) !== JSON.stringify(this.ControlParameters))) {
                        this.originalControlParams = this.ControlParameters;
                        this.LoadList(this.WebAPIUrl, this.ControlParameters, this.TextField, this.ValueField, this.ShowTextValueField, true, this.selectedIndex);
                    }
                }
                else if (this.dataSource && this.dataSource.length > 0) {
                    if (this.selectedIndex !== -1) {
                        this.procesAutocomplete(this.dataSource, this.selectedIndex);
                    }
                    else {
                        this.procesAutocomplete(this.dataSource);
                    }
                }
                else if (this.dataSource && this.dataSource.length === 0) {
                    this.selValue = '';
                    this.value = '';
                    this.codeListTemp = [];
                    this.codeList = [];
                    this.previousEmittedItem = null;
                }
            }
            if (event.hasOwnProperty('defaultValue')) {
                if (this.defaultValue && event.defaultValue && event.defaultValue.firstChange) {
                    this.setDefaultValue();
                }
                else {
                    if (event.defaultValue && this.previousEmittedItem) {
                        if (event.defaultValue.currentValue != this.previousEmittedItem.value) {
                            this.setDefaultValue();
                        }
                    }
                    else if (event.defaultValue && !this.previousEmittedItem) {
                        this.setDefaultValue();
                    }
                }
            }
            if (this.displaySettings && JSON.stringify(this.displaySettings) !== '{}') {
            }
        }
        else if (!this.IsDataOnload &&
            this.defaultValue !== null &&
            this.defaultValue !== undefined) {
            if (this.IsCascading) {
                if (this.dataSource && this.dataSource.length == 0) {
                    this.isDependentSelected = false;
                    if (this.ControlParameters) {
                        // this.ControlParameters['params']['param'][0]['value'] = $event.target.value;
                        if (this.ControlParameters.params.param) {
                            if (this.ControlParameters.params.param.filter(n => n['key'] == this.SearchTextKey).length > 0) {
                                this.ControlParameters.params.param.filter(n => n['key'] === this.SearchTextKey)[0]['value'] = this.defaultValue;
                            }
                        }
                        else {
                            if (this.ControlParameters.params) {
                                this.ControlParameters.params[this.SearchTextKey] = this.defaultValue;
                            }
                        }
                    }
                    this.LoadList(this.WebAPIUrl, this.ControlParameters, this.TextField, this.ValueField, this.ShowTextValueField, false, this.selectedIndex);
                }
                else {
                    if (this.dataSource && this.dataSource.length > 0) {
                        if (this.selectedIndex !== -1) {
                            this.procesAutocomplete(this.dataSource, this.selectedIndex);
                        }
                        else {
                            this.procesAutocomplete(this.dataSource);
                        }
                    }
                }
            }
            if (event.hasOwnProperty('defaultValue')) {
                if (this.defaultValue && event.defaultValue && event.defaultValue.firstChange) {
                    this.setDefaultValue();
                }
                else {
                    if (event.defaultValue && this.previousEmittedItem) {
                        if (event.defaultValue.currentValue != this.previousEmittedItem.value) {
                            this.setDefaultValue();
                        }
                    }
                    else if (event.defaultValue && !this.previousEmittedItem) {
                        this.setDefaultValue();
                    }
                }
            }
        }
        if (this.expandOptions) {
            this.optionStyles = 'payment-terms-autocomplete';
        }
    }
    ngAfterViewInit() {
        this.panelClosingActionSubscription = this.autocompleteTrigger.panelClosingActions.subscribe(x => {
            if (this.autocompleteTrigger.activeOption) {
                this.selValue = this.autocompleteTrigger.activeOption.value;
            }
            if (this.codeList.length == 1) {
                this.selValue = this.codeList[0].text;
            }
            // if (this.panelClosingActionSubscription) {
            //   this.panelClosingActionSubscription.unsubscribe();
            // }
        });
    }
    onKeyDown(event) {
        if (this.allowedDownKeys.indexOf(event.keyCode) !== -1) {
            // this.clearText();
        }
    }
    LoadList(WebAPIUrl, ControlParameters, TextField, ValueField, ShowTextValueField, isCascading, selectedIndex) {
        let headers = {};
        this.codeListTemp = [];
        this.codeList = [];
        WebAPIUrl = WebAPIUrl ? WebAPIUrl : this.WebAPIUrl;
        ControlParameters = ControlParameters ? ControlParameters : this.ControlParameters;
        ValueField = ValueField ? ValueField : this.ValueField;
        TextField = TextField ? TextField : this.TextField;
        headers = this.ControlParameters.headers;
        ControlParameters = ControlParameters['params'];
        if (this.isSpinnerRequired) {
            this.isLoading = true;
            this.IsDisabled = true;
        }
        this.isLoadingEnabled = true;
        const subscriber$ = this.autoCompleteService.httpPostCallWithHeader(WebAPIUrl, ControlParameters, headers)
            //  .pipe(tap(() => { this.isLoading = true; }))
            .subscribe(result => {
            const CollectionResult = result.table || result;
            this.isLoading = false;
            this.isLoadingEnabled = false;
            if (this.isSpinnerRequired === true) {
                this.IsDisabled = false;
            }
            if (CollectionResult) {
                this.procesAutocomplete(CollectionResult, selectedIndex);
            }
            subscriber$.unsubscribe();
        }, (error) => {
            this.isLoading = false;
            this.isLoadingEnabled = false;
            this.IsDisabled = false;
            if (subscriber$) {
                subscriber$.unsubscribe();
            }
        });
    }
    procesAutocomplete(collectionResult, selectedIndex) {
        this.codeListTemp = this.autocompleteHelper
            .getAutoCompleteList(collectionResult, this.ShowTextValueField, this.TextField, this.ValueField, this.displaySettings);
        if (collectionResult.length > 0) {
            if (collectionResult.length == 1) {
                if (this.SingleValueBind == false || this.defaultValue === null || this.defaultValue === '') {
                    selectedIndex = -1;
                }
                else {
                    selectedIndex = 0;
                }
            }
            else {
                // this.selValue = '';
                if (!selectedIndex && selectedIndex !== 0) {
                    selectedIndex = -1;
                }
            }
        }
        else {
            const selectedItem = this.autocompleteHelper.noRecordItem;
            this.codeListTemp.push(selectedItem);
            this.selValue = this.codeListTemp[0].text;
            this.emitSelectedValue(selectedItem, true);
        }
        this.defaultScrollCount = (this.defaultScrollCount <= 0) ? 50 : this.defaultScrollCount;
        this.codeList = this.codeListTemp.slice(0, this.defaultScrollCount);
        if (selectedIndex !== -1) {
            this._setFirstValue(selectedIndex);
        }
        else {
            if (this.codeListTemp[0].text !== 'No records found') {
                if (this.IsDataOnload) {
                    // this.selValue = '';
                }
            }
        }
        if (this.defaultValue && this.previousEmittedItem) {
            if (this.defaultValue != this.previousEmittedItem.value) {
                this.setDefaultValue();
            }
        }
        else if (this.defaultValue && !this.previousEmittedItem) {
            this.setDefaultValue();
        }
    }
    _setFirstValue(selectedIndex) {
        let firstobect = {};
        let value = '';
        firstobect = this.codeListTemp[selectedIndex];
        if (firstobect) {
            this.selValue = firstobect.text;
            value = firstobect.value;
            this.defaultValue = value;
        }
    }
    setDefaultValue() {
        let emittingValues = new EmittingValues();
        if (this.codeList &&
            ((this.defaultValue !== null && this.defaultValue !== undefined))) {
            this.codeListTemp.filter(element => {
                if (element.value !== null && element.value !== undefined && element.value !== '') {
                    if (element.value == this.defaultValue) {
                        this.selValue = element.text;
                        emittingValues = this.autocompleteHelper.getEmittingValues(element);
                        const value = emittingValues.value;
                        const text = emittingValues.text;
                        const desc = emittingValues.desc;
                        const additionalValues = emittingValues.additionalValues;
                        this.codeList = this.autocompleteHelper.filterTempList(this.codeListTemp, this.selValue);
                        if (this.emittedValue !== emittingValues.text) {
                            this.emittedValue = emittingValues.text;
                            if (this.ToolTipType == 'text') {
                                this.toolTipText = additionalValues.desc;
                            }
                            else if (this.ToolTipType == 'value') {
                                this.toolTipText = additionalValues.value;
                            }
                            else if (this.ToolTipType == 'text-value') {
                                this.toolTipText = additionalValues.desc + ' - ' + additionalValues.value;
                            }
                            else {
                                this.toolTipText = additionalValues.tooltip;
                            }
                            this.originalValue = text;
                            this.valueChange.emit({ value, text, desc, additionalValues });
                        }
                    }
                }
            });
        }
    }
    clickEvent() {
        const subscriber$ = this.autoCompleteService.getAutoCompleteList(this.ControlParameters, this.WebAPIUrl).subscribe(result => {
            const CollectionResult = result.table || result;
            if (this.ShowTextValueField == 'Y') {
                this.codeListTemp = CollectionResult.map((n) => ({
                    value: n[this.ValueField], text: n[this.ValueField] + ' - '
                        + n[this.TextField], desc: n[this.TextField],
                    additionalValues: n
                }));
            }
            else {
                this.codeListTemp = CollectionResult.map((n) => ({
                    value: n[this.ValueField],
                    text: n[this.TextField],
                    desc: n[this.TextField],
                    additionalValues: n
                }));
            }
            this.codeList = this.codeListTemp.slice(0, this.defaultScrollCount);
            subscriber$.unsubscribe();
        }, (error) => {
            // console.log(error)
            subscriber$.unsubscribe();
        });
    }
    HandleSpecialCharacter() {
        let isSplCharRemoved = false;
        let originalValue;
        if (this.AllowSplChars == 'Y') {
            const strsplit = this.AllowedSplChars.split('~');
            let splchars = '[^A-Za-z0-9';
            let i = 0;
            for (i = 0; i < strsplit.length; i++) {
                splchars += '\\' + strsplit[i];
            }
            splchars += '\\' + '--';
            splchars = splchars + ']';
            // console.log(splchars + " : splchars");
            const pattern = new RegExp(splchars);
            originalValue = this.selValue;
            this.selValue = this.selValue.replace(pattern, '');
            if (originalValue !== this.selValue) {
                isSplCharRemoved = true;
            }
        }
        return isSplCharRemoved;
    }
    _emitValues(selectedItem) {
        let value = '';
        let text = '';
        let desc = '';
        let additionalValues = {};
        // let _selectedItem = this.autocompleteHelper.filterExactTempList(this.codeListTemp, this.selValue)
        if (this.emittedValue.trim() !== this.selValue.trim()) {
            if (selectedItem && this.selValue !== 'No records found' && this.selValue !== '') {
                if (this.selValue.toLowerCase().trim() !== this.originalValue.toLowerCase().trim()) {
                    this.originalValue = this.selValue;
                    value = selectedItem.value;
                    text = selectedItem.text;
                    desc = selectedItem.desc;
                    additionalValues = selectedItem;
                    this.emittedValue = selectedItem.text;
                    // this.toolTipText = additionalValues.tooltip;
                    if (this.ToolTipType == 'text') {
                        this.toolTipText = additionalValues.desc;
                    }
                    else if (this.ToolTipType == 'value') {
                        this.toolTipText = additionalValues.value;
                    }
                    else if (this.ToolTipType == 'text-value') {
                        this.toolTipText = additionalValues.desc + ' - ' + additionalValues.value;
                    }
                    else {
                        this.toolTipText = additionalValues.tooltip;
                    }
                    if (selectedItem.value !== '-5') {
                        this.valueChange.emit({ value, text, desc, additionalValues });
                    }
                    this.value = text; // + ' ';
                }
            }
            else {
                this.selValue = (this.isIncludeInList || this.selValue.trim() == '') ? this.selValue.trim() : 'No records found';
                this.originalValue = this.selValue;
                value = selectedItem.value;
                text = this.selValue;
                desc = this.selValue;
                additionalValues = { tooltip: text };
                this.emittedValue = this.selValue;
                // this.toolTipText = additionalValues.tooltip;
                if (this.ToolTipType == 'text') {
                    this.toolTipText = additionalValues.desc;
                }
                else if (this.ToolTipType == 'value') {
                    this.toolTipText = additionalValues.value;
                }
                else if (this.ToolTipType == 'text-value') {
                    this.toolTipText = additionalValues.desc + ' - ' + additionalValues.value;
                }
                else {
                    this.toolTipText = additionalValues.tooltip;
                }
                if (selectedItem.value !== '-5') {
                    this.valueChange.emit({ value, text, desc, additionalValues });
                }
            }
        }
        else if (this.emittedValue.trim() == '' && this.selValue.trim() == '') {
            value = selectedItem.value;
            text = this.selValue;
            desc = this.selValue;
            additionalValues = { tooltip: text };
            this.emittedValue = this.selValue;
            // this.toolTipText = additionalValues.tooltip;
            if (this.ToolTipType == 'text') {
                this.toolTipText = additionalValues.desc;
            }
            else if (this.ToolTipType == 'value') {
                this.toolTipText = additionalValues.value;
            }
            else if (this.ToolTipType == 'text-value') {
                this.toolTipText = additionalValues.desc + ' - ' + additionalValues.value;
            }
            else {
                this.toolTipText = additionalValues.tooltip;
            }
            this.toolTipText = this.toolTipText && this.toolTipText.length === 0 ? this.NoSelectiontoolTip : this.toolTipText;
            if (selectedItem.value !== '-5') {
                this.valueChange.emit({ value, text, desc, additionalValues });
            }
        }
    }
    _getSelectedItem(selectedText) {
        let selectedItem;
        this.codeList.filter(element => {
            if (element.text.trim() == selectedText.trim()) {
                selectedItem = element;
                return;
            }
        });
        return selectedItem;
    }
    autocompleteScroll() {
        let scrollCount = 0;
        let tempList = [];
        setTimeout(() => {
            if (this.statesAutocompleteRef &&
                this.autocompleteTrigger &&
                this.statesAutocompleteRef.panel) {
                this.autoCompleteScrollSubscription = fromEvent(this.statesAutocompleteRef.panel.nativeElement, 'scroll')
                    .pipe(map(x => this.statesAutocompleteRef.panel.nativeElement.scrollTop), takeUntil(this.autocompleteTrigger.panelClosingActions))
                    .subscribe(x => {
                    const scrollTop = this.statesAutocompleteRef.panel.nativeElement
                        .scrollTop;
                    const scrollHeight = this.statesAutocompleteRef.panel.nativeElement
                        .scrollHeight;
                    const elementHeight = this.statesAutocompleteRef.panel.nativeElement
                        .clientHeight;
                    const atBottom = scrollHeight == scrollTop + elementHeight;
                    if (atBottom) {
                        if (this.selValue) {
                            tempList = this.codeListTemp.filter(option => option.text.toLowerCase().trim().includes(this.selValue.toLowerCase().trim()));
                            if (this.codeList.length < tempList.length) {
                                scrollCount = tempList.length - this.codeList.length;
                                if (scrollCount < 50) {
                                    this.codeList = [...this.codeList, ...tempList.slice(this.codeList.length, this.codeList.length + scrollCount)];
                                }
                                else {
                                    if (this.codeList.length >= 50) {
                                        this.codeList = [...this.codeList, ...tempList.slice(this.codeList.length, this.codeList.length + 50)];
                                    }
                                }
                            }
                        }
                        else {
                            if (this.codeList.length < this.codeListTemp.length) {
                                scrollCount = this.codeListTemp.length - this.codeList.length;
                                if (scrollCount < 50) {
                                    this.codeList = [...this.codeList,
                                        ...this.codeListTemp.slice(this.codeList.length, this.codeList.length + scrollCount)];
                                }
                                else {
                                    this.codeList = [...this.codeList, ...this.codeListTemp.slice(this.codeList.length, this.codeList.length + 50)];
                                }
                            }
                        }
                    }
                });
                this.onBlurAuto();
            }
        });
    }
    clearText() {
        setTimeout(() => {
            this.codeList = this.codeListTemp.slice(0, this.defaultScrollCount);
            this.autocompleteScroll();
            this.previousEmittedItem = null;
            this.selValue = '';
            this.value = '';
        });
        if (!this.IsDataOnload) {
            this.loadApiCount = 0;
            // this.codeListTemp = [];
            // this.codeList = [];
        }
    }
    filterText(selectedText) {
        this.selValue = selectedText;
        const isSplCharRemoved = this.HandleSpecialCharacter();
        let selectedItem = {};
        const inputElement = document.getElementById(this.setId);
        selectedText = this.leftTrim(selectedText);
        inputElement.value = selectedText;
        inputElement.maxLength = this.Max;
        if (selectedText.length <= this.Max) {
            if (selectedText.trim() == '') {
                this.codeList = this.codeListTemp.slice(0, 50);
            }
            else {
                if (this.autocompleteHelper.isExactMatchInList(this.codeListTemp, this.selValue.trim())) {
                    selectedItem = this.autocompleteHelper.filterExactTempList(this.codeListTemp, this.selValue.trim());
                    if (selectedItem) {
                        this._emitValues(selectedItem);
                    }
                }
                this.codeList = this.autocompleteHelper.filterTempList(this.codeListTemp, selectedText);
            }
        }
        this.onBlurAuto();
    }
    onKeyup($event) {
        if ($event.key == 'Backspace') {
            if ($event.target.value == '') {
                this.clearText();
                this.loadApiCount = 0;
                if (this.ControlParameters) {
                    if (this.ControlParameters.params.hasOwnProperty('strSearchText'))
                        this.ControlParameters.params['strSearchText'] = '';
                }
                // this.codeListTemp = [];
                // this.codeList = [];
            }
        }
        setTimeout(() => {
            if (!this.IsDataOnload) {
                if (this.Minlength) {
                    if ($event.target.value.length <= this.Minlength) {
                        this.loadApiCount = 0;
                    }
                    if (this.ControlParameters) {
                        // this.ControlParameters['params']['param'][0]['value'] = $event.target.value;
                        if (this.ControlParameters.params.param) {
                            if (this.ControlParameters.params.param.filter(n => n['key'] == this.SearchTextKey).length > 0) {
                                this.ControlParameters.params.param.filter(n => n['key'] === this.SearchTextKey)[0]['value'] = $event.target.value;
                            }
                        }
                        else {
                            if (this.ControlParameters.params) {
                                this.ControlParameters.params[this.SearchTextKey] = $event.target.value;
                            }
                        }
                    }
                    if ($event.target.value.length >= this.Minlength && this.loadApiCount == 0) {
                        this.loadApiCount = 1;
                        if (this.IsCascading) {
                            if ((this.ControlParameters &&
                                (JSON.stringify(this.ControlParameters) !== '{}')) &&
                                (this.dataSource || this.dataSource.length == 0)) {
                                if (JSON.stringify(this.originalControlParams) == '{}' ||
                                    (JSON.stringify(this.originalControlParams) !== JSON.stringify(this.ControlParameters))) {
                                    this.originalControlParams = JSON.parse(JSON.stringify(this.ControlParameters));
                                    this.LoadList(this.WebAPIUrl, this.ControlParameters, this.TextField, this.ValueField, this.ShowTextValueField, true, this.selectedIndex);
                                }
                            }
                            else if (this.dataSource && this.dataSource.length > 0) {
                                if (this.selectedIndex !== -1) {
                                    this.procesAutocomplete(this.dataSource, this.selectedIndex);
                                }
                                else {
                                    this.procesAutocomplete(this.dataSource);
                                }
                                // this.procesAutocomplete(this.dataSource);
                            }
                        }
                    }
                }
            }
        }, 1000);
    }
    leftTrim(selectedText) {
        return selectedText.replace(/^\s+/, '');
    }
    // get accessor
    get value() {
        return this.selValue;
    }
    // set accessor including call the onchange callback
    set value(v) {
        if (v == this.selValue) {
            this.selValue = v;
            this.onChangeCallback(v);
            this.autocompleteScroll();
        }
    }
    // Set touched on blur
    onBlurAuto() {
        this.onTouchedCallback();
    }
    // From ControlValueAccessor interface
    writeValue(value) {
        if (value !== this.selValue) {
            this.selValue = value;
        }
    }
    // From ControlValueAccessor interface
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    // From ControlValueAccessor interface
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    getPosts(event) {
        // console.log(event, 'selected');
    }
    handleMetaSignalChange(metaSignal, event) {
        if (event.isUserInput) { // ignore on deselection of the previous option
            //  console.log('Meta Signal Changed to ' + metaSignal + event.isUserInput);
        }
    }
    trackByAutoComplete(index, item) {
        // console.log(eventAutoComplete, 'trackBy from autoC');
        // console.log(index,'trackby item')
        // ; trackBy:trackByAutoComplete; let i=index
        return item.value;
    }
    ngOnDestroy() {
        if (this.panelClosingActionSubscription) {
            this.panelClosingActionSubscription.unsubscribe();
        }
        if (this.autoCompleteScrollSubscription) {
            this.autoCompleteScrollSubscription.unsubscribe();
        }
        // if (this.autoCompleteScrollSubscription) {
        //   this.autoCompleteScrollSubscription.unsubscribe();
        // }
    }
    /* Auto complete changes made by christopher on 06-09-2021 start*/
    emitSelectedValue(item, inValid) {
        const itemText = item.text.trim();
        this.toolTipText = (!inValid) ? this.autocompleteHelper.getTooltipText(item, this.ToolTipType) : '';
        this.selValue = itemText;
        this.value = itemText;
        const selectedItem = {
            value: item.value, text: item.text, desc: item.desc, additionalValues: item
        };
        this.valueChange.emit(selectedItem);
    }
    onFocusOut(event) {
        if (event.relatedTarget && event.relatedTarget.tagName === 'MAT-OPTION') {
            return true;
        }
        else {
            const value = this.value.trim();
            if (value) {
                this.onAutoCompleteChanges();
            }
            else {
                this.callEvent({ value: '', text: '' });
            }
        }
    }
    onAutoCompleteChanges() {
        const value = this.value.trim();
        if (value) {
            if (this.codeList.length == 1) {
                this.selValue = this.codeList[0].text.trim();
                this.autocompleteTrigger.closePanel();
                const selectedValue = this.codeList[0].value.toString();
                if (this.selValue) {
                    this.callEvent({ value: selectedValue, text: this.selValue });
                }
            }
            else if (this.codeList.length <= 0) {
                this.selValue = value;
                this.callEvent({ value: this.selValue, text: this.selValue });
            }
        }
    }
    onSelectionChange(event, item) {
        if (event.source.selected) {
            const value = (item) ? item.value.toString().trim() : '';
            const previousValue = (this.previousEmittedItem) ? this.previousEmittedItem.value : '';
            if (value && previousValue != value) {
                if (item) {
                    this.previousEmittedItem = item;
                    this.codeList = [item];
                    this.autocompleteTrigger.closePanel();
                    this.emitSelectedValue(item);
                }
                else {
                    this.previousEmittedItem = null;
                }
            }
        }
    }
    callEvent(item) {
        if (!item.text) {
            this.selValue = '';
            this.value = '';
            this.previousEmittedItem = null;
            if (this.autocompleteTrigger) {
                this.autocompleteTrigger.closePanel();
            }
            this.emitSelectedValue(this.autocompleteHelper.emptyItem, true);
        }
        else {
            const previousValue = (this.previousEmittedItem) ? this.previousEmittedItem.value : '';
            if (item.value && previousValue != item.value) {
                const selectedItem = this.autocompleteHelper.filterExactTempList(this.codeListTemp, item.value);
                if (selectedItem) {
                    this.previousEmittedItem = item;
                    this.codeList = [selectedItem];
                    this.autocompleteTrigger.closePanel();
                    this.emitSelectedValue(selectedItem);
                }
            }
            if (!(this.autocompleteHelper.isIncludeInList(this.codeListTemp, item.text))) {
                if (this.typeEmitted) {
                    const previousText = (this.previousEmittedItem) ? this.previousEmittedItem.text : '';
                    if (previousText !== item.text) {
                        const newItem = this.autocompleteHelper.mappingAutocompleteItem(item.text);
                        this.previousEmittedItem = newItem;
                        this.emitSelectedValue(newItem);
                    }
                }
                else {
                    if (!this.isLoadingEnabled) {
                        this.previousEmittedItem = null;
                        this.emitSelectedValue(this.autocompleteHelper.noRecordItem, true);
                    }
                }
            }
        }
    }
}
EIPAutoCompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPAutoCompleteComponent, deps: [{ token: EIPAutoCompleteService }], target: i0.ɵɵFactoryTarget.Component });
EIPAutoCompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EIPAutoCompleteComponent, selector: "EIPAutoComplete", inputs: { WebAPIUrl: "WebAPIUrl", ControlParameters: "ControlParameters", TextField: "TextField", ValueField: "ValueField", AllowedSplChars: "AllowedSplChars", AllowSplChars: "AllowSplChars", WaterMarkText: "WaterMarkText", setId: "setId", IsDisabled: "IsDisabled", ShowTextValueField: "ShowTextValueField", Minlength: "Minlength", Max: "Max", collectionType: "collectionType", defaultValue: "defaultValue", selectedIndex: "selectedIndex", IsCascading: "IsCascading", clearValue: "clearValue", ItemWidth: "ItemWidth", dataSource: "dataSource", displaySettings: "displaySettings", expandOptions: "expandOptions", floatLabelOption: "floatLabelOption", SingleValueBind: "SingleValueBind", typeEmitted: "typeEmitted", IsDataOnload: "IsDataOnload", isRequired: "isRequired", SearchTextKey: "SearchTextKey", disabledItem: "disabledItem", isSpinnerRequired: "isSpinnerRequired", NoSelectiontoolTip: "NoSelectiontoolTip", ClearListCollection: "ClearListCollection" }, outputs: { valueChange: "valueChange" }, providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "statesAutocompleteRef", first: true, predicate: ["auto"], descendants: true }, { propertyName: "autocompleteTrigger", first: true, predicate: MatAutocompleteTrigger, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<mat-form-field [floatLabel]=\"'always'\" class=\"example-full-width eip-auto-complete\">\r\n    <input [id]=\"setId\" [disabled]=\"IsDisabled\" type=\"text\" [required]=\"isRequired\" [placeholder]=\"WaterMarkText\"\r\n        [minlength]=\"Minlength\" [maxLength]='Max' [(ngModel)]=\"value\" (keydown.enter)='onAutoCompleteChanges()'\r\n        (ngModelChange)=\"filterText($event)\" (keyup)=\"onKeyup($event)\" (keydown)\u00A0=\u00A0\"onKeyDown($event)\" matInput\r\n        autocomplete=\"off\" [matAutocomplete]=\"auto\" [title]='toolTipText' (focusout)=\"onFocusOut($event)\">\r\n    <div *ngIf=\"isLoading\" class=\"k-i-loading\"></div>\r\n    <span *ngIf=\"value && !IsDisabled\" (click)=\"clearText()\" title=\"clear\" matSuffix\r\n        class=\"fa fa-times cursor-pointer\"></span>\r\n    <i\u00A0class=\"fa fa-caret-down float-right mr-1\"\u00A0style=\"position: absolute;right:0px;\"></i>\r\n\r\n    <mat-autocomplete #auto='matAutocomplete' [class]=\"optionStyles\" [panelWidth]=\"ItemWidth\"\r\n        (opened)=\"autocompleteScroll()\" md-search-text=\"value\" md-item-text=\"option.text\" md-menu-class=\"autocomplete\"\r\n        md-highlight-text=\"value\" md-highlight-flags=\"^i\">\r\n        <mat-option class=\"eip-auto-complete-option\" width=\"80%\" *ngFor=\"let option of codeList\" [value]=\"option.text\"\r\n            (onSelectionChange)=\"onSelectionChange($event,option)\" [title]='option.tooltip'>\r\n            <span [innerHTML]=\"option.text | highlight: value\"></span>\r\n        </mat-option>\r\n    </mat-autocomplete>\r\n</mat-form-field>", styles: [".drpdwnicon{position:absolute;right:1px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAABp0lEQVRYhe2TsUsbURyAv19MHFzuLocUMniF0P/AwaWDDpZSaFXQSSiUDuLikKWDi0OXLg4dXCx06GIHqR2KOCi4OLg4yzt4F0IWId6BWINNnkss5Wrj5arp0PvG9378vu8NDzIyMv53pOx5FciN/xt9e09KpdLQUH5wE+FJn+3bF60fM7l6vX7OYP4Fhq2+qQ1bFPJTtVrtew5AKdW0ht1ZhM99kG9Yw+6sUqoJILHrgUcjDz8Y4eW9uA0f/ap+DbR+CuMzjSj86lj2AxFG79i/5lf1AtD+9TAeAGBOo/Bb0bIthLE7kq+qQC8BJn5xUwAAjSjcKdpOAXj8N2ZB3qpAv7lJ3jWgE7Hr2k4LmEgjN5hlFeiVbjNdAzoR+45tnQky2aO+4gfBu9umbg0AOI2ig6JtnYA8S+QWFlUQvE8ymigAoBFFh65jV4Hn/P59r2mL8EppvZ50b+IAgEYYHrmOfQxMAbnYdcsI80rrT73s/NNLulL2vGlBNoBC5+jSCHO+1l963ZUqoBPxVJBNACNM+1pvp92VmrLnTZQ9L9UXzcjIyLjmCsCxgkI3BM8oAAAAAElFTkSuQmCC)}.mat-input-element{width:88%}.mat-option{font-size:14px;padding:0 10px!important;height:30px!important;color:#333!important}.mat-form-field-appearance-legacy .mat-form-field-underline{height:3px!important;background-color:#1367a3}.cdk-overlay-pane{top:54px!important;border:2px solid #446f8b;box-shadow:none}.mat-form-field.mat-form-field-invalid .mat-form-field-label{color:#333}.mat-form-field.mat-form-field-invalid .mat-form-field-ripple,.mat-form-field.mat-form-field-invalid .mat-form-field-ripple.mat-accent{background-color:#1367a3}.is-loading ::ng-deep .mat-option-text{display:flex;justify-content:center}.k-i-loading{position:absolute;top:0px;left:0;right:0;bottom:0;font-size:30px;background-color:#ffffff4d;color:#ff6757;z-index:999}\n"], components: [{ type: i2.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { type: i3.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i4.MatOption, selector: "mat-option", exportAs: ["matOption"] }], directives: [{ type: i5.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i6.MinLengthValidator, selector: "[minlength][formControlName],[minlength][formControl],[minlength][ngModel]", inputs: ["minlength"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i7.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.MatSuffix, selector: "[matSuffix]" }, { type: i7.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "highlight": HighlightSearch } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPAutoCompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'EIPAutoComplete', styles: [`
  .drpdwnicon{
    position: absolute;;
    right : 1px;
    background-image:url("./dropdownicon.png")
     }

.mat-input-element {
  width:88%;
}
.mat-option {
  font-size: 14px;
  padding: 0 10px !important;
  height: 30px !important;
  color:#333333 !important;
}
.mat-form-field-appearance-legacy .mat-form-field-underline{
  height: 3px !important;
  background-color:  #1367a3;

}
.cdk-overlay-pane{
  top:54px !important;
  border: 2px solid  #446f8b ;
    box-shadow: none;

}
.mat-form-field.mat-form-field-invalid .mat-form-field-label {
    color: #333333;
}
.mat-form-field.mat-form-field-invalid .mat-form-field-ripple, .mat-form-field.mat-form-field-invalid .mat-form-field-ripple.mat-accent {
  background-color:  #1367a3;
}

.is-loading ::ng-deep .mat-option-text {
  display: flex;
  justify-content: center;
}

.k-i-loading {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 30px;
  background-color: rgba(255, 255, 255, .3);
  color: #ff6757;
  z-index: 999;
}

  `], providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR], template: "<mat-form-field [floatLabel]=\"'always'\" class=\"example-full-width eip-auto-complete\">\r\n    <input [id]=\"setId\" [disabled]=\"IsDisabled\" type=\"text\" [required]=\"isRequired\" [placeholder]=\"WaterMarkText\"\r\n        [minlength]=\"Minlength\" [maxLength]='Max' [(ngModel)]=\"value\" (keydown.enter)='onAutoCompleteChanges()'\r\n        (ngModelChange)=\"filterText($event)\" (keyup)=\"onKeyup($event)\" (keydown)\u00A0=\u00A0\"onKeyDown($event)\" matInput\r\n        autocomplete=\"off\" [matAutocomplete]=\"auto\" [title]='toolTipText' (focusout)=\"onFocusOut($event)\">\r\n    <div *ngIf=\"isLoading\" class=\"k-i-loading\"></div>\r\n    <span *ngIf=\"value && !IsDisabled\" (click)=\"clearText()\" title=\"clear\" matSuffix\r\n        class=\"fa fa-times cursor-pointer\"></span>\r\n    <i\u00A0class=\"fa fa-caret-down float-right mr-1\"\u00A0style=\"position: absolute;right:0px;\"></i>\r\n\r\n    <mat-autocomplete #auto='matAutocomplete' [class]=\"optionStyles\" [panelWidth]=\"ItemWidth\"\r\n        (opened)=\"autocompleteScroll()\" md-search-text=\"value\" md-item-text=\"option.text\" md-menu-class=\"autocomplete\"\r\n        md-highlight-text=\"value\" md-highlight-flags=\"^i\">\r\n        <mat-option class=\"eip-auto-complete-option\" width=\"80%\" *ngFor=\"let option of codeList\" [value]=\"option.text\"\r\n            (onSelectionChange)=\"onSelectionChange($event,option)\" [title]='option.tooltip'>\r\n            <span [innerHTML]=\"option.text | highlight: value\"></span>\r\n        </mat-option>\r\n    </mat-autocomplete>\r\n</mat-form-field>" }]
        }], ctorParameters: function () { return [{ type: EIPAutoCompleteService }]; }, propDecorators: { WebAPIUrl: [{
                type: Input
            }], ControlParameters: [{
                type: Input
            }], TextField: [{
                type: Input
            }], ValueField: [{
                type: Input
            }], AllowedSplChars: [{
                type: Input
            }], AllowSplChars: [{
                type: Input
            }], WaterMarkText: [{
                type: Input
            }], setId: [{
                type: Input
            }], IsDisabled: [{
                type: Input
            }], ShowTextValueField: [{
                type: Input
            }], Minlength: [{
                type: Input
            }], Max: [{
                type: Input
            }], collectionType: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], selectedIndex: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], IsCascading: [{
                type: Input
            }], clearValue: [{
                type: Input
            }], ItemWidth: [{
                type: Input
            }], dataSource: [{
                type: Input
            }], displaySettings: [{
                type: Input
            }], expandOptions: [{
                type: Input
            }], floatLabelOption: [{
                type: Input
            }], SingleValueBind: [{
                type: Input
            }], typeEmitted: [{
                type: Input
            }], IsDataOnload: [{
                type: Input
            }], isRequired: [{
                type: Input
            }], SearchTextKey: [{
                type: Input
            }], disabledItem: [{
                type: Input
            }], statesAutocompleteRef: [{
                type: ViewChild,
                args: ['auto', { static: false }]
            }], autocompleteTrigger: [{
                type: ViewChild,
                args: [MatAutocompleteTrigger, { static: false }]
            }], isSpinnerRequired: [{
                type: Input
            }], NoSelectiontoolTip: [{
                type: Input
            }], ClearListCollection: [{
                type: Input
            }] } });

class OrderBySearchPipe {
    transform(value, propertyName) {
        if (propertyName)
            return value.sort((a, b) => b[propertyName].localeCompare(a[propertyName]));
        else
            return value;
    }
}
OrderBySearchPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OrderBySearchPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
OrderBySearchPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OrderBySearchPipe, name: "orderBy" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: OrderBySearchPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'orderBy',
                    pure: true
                }]
        }] });

class EIPPipe {
}
EIPPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPPipe, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EIPPipe.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPPipe, declarations: [HighlightSearch, OrderBySearchPipe], imports: [CommonModule], exports: [HighlightSearch, OrderBySearchPipe] });
EIPPipe.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPPipe, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPPipe, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HighlightSearch, OrderBySearchPipe],
                    imports: [CommonModule],
                    exports: [HighlightSearch, OrderBySearchPipe]
                }]
        }] });

class EIPAutoCompleteModule {
}
EIPAutoCompleteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPAutoCompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EIPAutoCompleteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPAutoCompleteModule, declarations: [EIPAutoCompleteComponent], imports: [CommonModule,
        FormsModule, ReactiveFormsModule, MatAutocompleteModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatRippleModule,
        HttpClientModule, EIPPipe], exports: [EIPAutoCompleteComponent] });
EIPAutoCompleteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPAutoCompleteModule, providers: [], imports: [[
            CommonModule,
            FormsModule, ReactiveFormsModule, MatAutocompleteModule,
            MatButtonModule,
            MatFormFieldModule,
            MatInputModule,
            MatRippleModule,
            HttpClientModule, EIPPipe
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPAutoCompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EIPAutoCompleteComponent],
                    imports: [
                        CommonModule,
                        FormsModule, ReactiveFormsModule, MatAutocompleteModule,
                        MatButtonModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatRippleModule,
                        HttpClientModule, EIPPipe
                    ],
                    providers: [],
                    exports: [EIPAutoCompleteComponent]
                }]
        }] });

/*
 * Public API Surface of eipauto-complete
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, EIPAutoCompleteComponent, EIPAutoCompleteModule, EIPAutoCompleteService };
